import {connect} from '../../app/connect';
import {
  getAnalyticsId,
  getIssueAttributeDefinitionsWhichAreMappedToIssueTypes,
  getIssuesCollectionError,
  getIssuesCollectionLoading,
  getProjectId,
  getEntityUserNameGetter,
  getUserNameWithCompanyGetter,
  getDeletedUsersFetched
} from '../../app/selectors';
import ProjectListMatrixTable from './ProjectListMatrixTable';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const mapStateToProps = state => ({
  customAttributes: getIssueAttributeDefinitionsWhichAreMappedToIssueTypes(state),
  loading: getIssuesCollectionLoading(state),
  isSortByTypeAndRootCauseEnabled: featureFlags.get(FEATURE_FLAGS.SORT_BY_TYPE_AND_ROOT_CAUSE),
  projectId: getProjectId(state),
  error: getIssuesCollectionError(state),
  analyticsId: getAnalyticsId(state),
  getUserDisplayNameWithCompany: getUserNameWithCompanyGetter(state),
  getEntityDisplayNameById: getEntityUserNameGetter(state),
  isDeletedUsersFetched: featureFlags.get(FEATURE_FLAGS.FETCH_DELETED_USERS) ? getDeletedUsersFetched(state) : true
});

export default connect(mapStateToProps)(ProjectListMatrixTable);
